var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "16px",
    viewBox: "0 0 15 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "facebook-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "facebook-icon",
    transform: "translate(0.000000, 0.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5677598,15.1060187 L9.8775188,15.1060187 L9.8775188,9.39022784 L11.7542473,9.39022784 L12.0387199,6.94060319 L9.8775188,6.94060319 L9.8775188,5.47858554 C9.8775188,4.8253523 10.0474121,4.49097853 10.9561438,4.49097853 L12.2481233,4.49097853 L12.2481233,2.35531411 C11.8530225,2.32673515 11.2406164,2.26549453 10.4385618,2.26549453 C8.7712367,2.26549453 7.5069143,3.31883314 7.5069143,5.25403661 L7.5069143,6.94060319 L5.5314105,6.94060319 L5.5314105,9.39022784 L7.5069143,9.39022784 L7.5069143,15.1060187 L0.6637693,15.1060187 C0.2212564,15.1060187 0,14.6197682 0,14.1625049 L0,0.828381404 C0,0.371118135 0.2212564,0 0.6637693,0 L13.5677598,0 C14.0063216,0 14.223627,0.371118135 14.223627,0.828381404 L14.223627,14.1625049 C14.223627,14.6197682 14.0063216,15.1060187 13.5677598,15.1060187 Z",
    id: "Path"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebook-icon.5810b280ab00540f56aec5c3b36fc8db.svg";
export { ForwardRef as ReactComponent };